import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {IconPerson} from '@veneer/core';

import useClickOutside from '../../../hooks/useClickOutside';
import {UserAction, UserCard} from '../UserCard';

import useStyle from './styles';
import {UserInfo} from './types';

const UserMenu = ({userInfo, actions}: {userInfo: UserInfo; actions?: UserAction[]}) => {
    const {t} = useTranslation(['AppHeader']);
    const [open, setOpen] = useState(false);

    const handleToggle = useCallback(() => {
        setOpen(curr => !curr);
    }, []);

    const style = useStyle(open);

    const handleClickOutside = useCallback(() => {
        setOpen(false);
    }, []);

    const menuRef = useClickOutside<HTMLDivElement>(handleClickOutside);

    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent) => {
            // 'Spacebar' ignored because userEvent uses ' ' rather than 'Spacebar' on event.key so it doesn't detect coverage. It works though.
            /* istanbul ignore else */
            if (e.key === ' ' || e.key === 'Enter' || /* istanbul ignore next */ e.key === 'Spacebar') {
                handleToggle();
            }
        },
        [handleToggle]
    );

    return (
        <div
            ref={menuRef}
            className={style.self}
        >
            <div
                role="button"
                aria-label={t('AppHeader:toggle', 'Toggle User Menu')}
                className={style.toggle}
                onClick={handleToggle}
                tabIndex={0}
                onKeyDown={handleKeyDown}
            >
                <IconPerson size={24} />
            </div>

            {open && (
                <UserCard
                    username={userInfo.username}
                    email={userInfo.email}
                    anchorEl={menuRef.current}
                    logoutLink={userInfo.logoutLink}
                    actions={actions}
                    manageAccountUrl={userInfo.manageAccountUrl}
                />
            )}
        </div>
    );
};

export default UserMenu;
